import {getter} from "@progress/kendo-data-query"
import {getSelectedState, Grid, GridColumn, GridSelectionChangeEvent} from "@progress/kendo-react-grid"
import {MDBCard, MDBCardBody, MDBCardTitle, MDBCol} from "mdbreact"
import {useCallback, useEffect} from "react"
import {
    fetchDealers,
    fetchRegions,
    setRegion,
    setRegionSelection,
    setSelectedRegion,
} from "../../containers/RegionAndDealers/RADSlice"
import {RootState} from "../../rootReducer"
import {SpinnerGrid} from "../../shared/CommonItems"
import {useAppDispatch, useAppSelector} from "../../store"

const DATA_ITEM_KEY = "regionId"
const SELECTED_FIELD = "selected"
const idGetter = getter(DATA_ITEM_KEY)

const RegionGrid = () => {
    const dispatch = useAppDispatch()

    const isRegionLoading = useAppSelector((state: RootState) => state.containers.regions.isRegionLoading)
    const regions = useAppSelector((state: RootState) => state.containers.regions.regions)
    const regionSelection = useAppSelector((state: RootState) => state.containers.regions.regionSelection)

    useEffect(() => dispatch(fetchRegions()), [dispatch])

    const onSelectionChange = useCallback(
        (event: GridSelectionChangeEvent) => {
            const newSelectedState = getSelectedState({
                event,
                selectedState: regionSelection,
                dataItemKey: DATA_ITEM_KEY,
            })
            const selectedRegionId = parseInt(Object.keys(newSelectedState)[0])
            dispatch(setRegionSelection(newSelectedState))
            dispatch(fetchDealers(selectedRegionId))
            const selectionRegion = regions.find(id => id.regionId === selectedRegionId)
            selectionRegion !== undefined && dispatch(setRegion(selectionRegion))
            dispatch(setSelectedRegion(selectionRegion !== undefined ? selectionRegion?.regionName : ""))
        },
        [regionSelection, regions],
    )

    return (
        <MDBCol md="4" className="pe-0">
            <div className="position-relative">
                {isRegionLoading && <SpinnerGrid />}
                <MDBCard>
                    <MDBCardBody className="p-2">
                        <MDBCardTitle className="text-muted mb-0 pb-2 pt-2">Regions</MDBCardTitle>
                        <Grid
                            data={regions.map(item => ({
                                ...item,
                                [SELECTED_FIELD]: regionSelection[idGetter(item)],
                            }))}
                            style={{height: "calc(100vh - 13.4rem)"}}
                            dataItemKey={DATA_ITEM_KEY}
                            selectedField={SELECTED_FIELD}
                            selectable={{
                                enabled: true,
                                drag: false,
                                cell: false,
                                mode: "single",
                            }}
                            onSelectionChange={onSelectionChange}
                        >
                            <GridColumn field="regionName" title="Region" />
                        </Grid>
                    </MDBCardBody>
                </MDBCard>
            </div>
        </MDBCol>
    )
}

export default RegionGrid
